import Swiper, {EffectCards, Navigation, Pagination} from 'swiper';

const contentBlocks = document.querySelectorAll('.j-intro-content');
const breakpoint = window.matchMedia('(min-width:1280px)');
const interleaveOffset = 1;
const options = {
    modules: [Navigation, Pagination, EffectCards],

    loop: false,

    speed: 800,

    slidesPerView: 1,

    watchSlidesProgress: true,

    pagination: {
        el: '.j-intro-pagination',

        type: 'custom',

        renderCustom(_, current, total) {
            const newCurrent = current < 10 ? `0${current}` : current;
            const newTotal = total < 10 ? `0${total}` : total;

            return `<span class="slider-control__current">${newCurrent}</span>
                       <span class="slider-control__total">/ ${newTotal}</span>`;
        }
    },
    navigation: {
        nextEl: '.j-intro-btn-next',
        prevEl: '.j-intro-btn-prev'
    },
    on: {
        init() {
            contentBlocks[0].classList.add('is-active');
        }
    },
    breakpoints: {
        1280: {
            allowTouchMove: false
        }
    }
};

let swiper = null;
let titleSlider = null;
let prevIndex = 0;

const setCurrentContentBlock = () => {
    if (Boolean(contentBlocks[prevIndex]) && contentBlocks[prevIndex].classList.contains('is-active')) {
        contentBlocks[prevIndex].classList.remove('is-active');
    }

    requestAnimationFrame(() => {
        contentBlocks[swiper.realIndex].classList.add('is-active');
    });

    prevIndex = swiper.realIndex;
    titleSlider.slideTo(swiper.realIndex);
};

const setTransformToDesktop = (index, offset) => {
    if ((index + 1) % 2 === 0 && swiper.realIndex !== index) {
        swiper.slides[index].style.transform =
            `translate3d(${-offset}px, 0, 0) scale(1.2)`;
        swiper.slides[index].style.zIndex = '0';
    } else if (swiper.realIndex === index) {
        swiper.slides[index].style.transform =
            `translate3d(${0}px, 0, 0) scale(1)`;
        swiper.slides[index].style.zIndex = '1';
    } else {
        swiper.slides[index].style.transform =
            `translate3d(${offset}px, 0, 0) scale(1.2)`;
        swiper.slides[index].style.zIndex = '0';
    }
};

const handleSwiperTouchStart = (currentSwiper) => {
    for (let i = 0; i < currentSwiper.slides.length; i++) {
        currentSwiper.slides[i].style.transition = '';
    }
};

const handleSwiperTransition = (currentSwiper, speed) => {
    for (let i = 0; i < currentSwiper.slides.length; i++) {
        currentSwiper.slides[i].style.transition = `transform ${speed}ms ease`;
        currentSwiper.slides[i].querySelector('.intro-main__img').style.transition = `${speed}ms`;
    }
};

const handleSlideChange = (currentSwiper) => {
    for (let i = 0; i < currentSwiper.slides.length; i++) {
        const slideProgress = currentSwiper.slides[i].progress;
        const innerOffset = currentSwiper.width * interleaveOffset;
        const innerTranslate = slideProgress * innerOffset;

        if (breakpoint.matches) {
            requestAnimationFrame(() => {
                currentSwiper.$wrapperEl[0].dataset.step = currentSwiper.realIndex;
                currentSwiper.$wrapperEl[0].style.transform = `translate3d(0, 0, 0)`;

                setTransformToDesktop(i, innerOffset);
            });
        } else {
            requestAnimationFrame(() => {
                if (currentSwiper.realIndex < i) {
                    currentSwiper.slides[i].querySelector('.intro-main__img').style.transform =
                        `translate3d(${innerTranslate}px, 0, 0) scale(1.2)`;
                } else {
                    currentSwiper.slides[i].querySelector('.intro-main__img').style.transform =
                        `translate3d(${innerTranslate}px, 0, 0) scale(1)`;
                }
            });
        }
    }

    setCurrentContentBlock();
};

const initTitleSlider = () => {
    return new Swiper('.j-title-slider', {
        loop: false,

        allowTouchMove: false,

        speed: 1000,

        slidesPerView: 1,

        spaceBetween: 6,

        direction: 'vertical'
    });
};

const initSwiper = (slider) => {
    titleSlider = initTitleSlider();

    swiper = new Swiper(slider, options);

    swiper.on('slideChange', handleSlideChange);
    swiper.on('resize', handleSlideChange);
    swiper.on('touchStart', handleSwiperTouchStart);
    swiper.on('setTransition', handleSwiperTransition);
};

const changeBreakpoint = (evt) => {
    const matches = evt ? evt.matches : breakpoint.matches;

    if (matches) {
        const innerOffset = swiper.width * interleaveOffset;

        for (let i = 0; i < swiper.slides.length; i++) {
            swiper.slides[i].querySelector('.intro-main__img').style.transform = '';

            setTransformToDesktop(i, innerOffset);
        }
    } else {
        for (let i = 0; i < swiper.slides.length; i++) {
            swiper.slides[i].style.transform = '';
        }
    }
};

const initIntroSlider = (introSlider) => {
    if (!introSlider || !contentBlocks) {
        return;
    }

    initSwiper(introSlider);

    breakpoint.addListener(changeBreakpoint);

    changeBreakpoint();
};

export {initIntroSlider};
